import autoTableFilterDatepicker from './filter/link-auto-table-filter-datepicker'
import autoTableFilterTimepicker from './filter/link-auto-table-filter-timepicker'
import autoTableFilterInput from './filter/link-auto-table-filter-input'
import autoTableFilterLov from './filter/link-auto-table-filter-lov'
import autoTableFilterInputNumber from './filter/link-auto-table-filter-input-number'

import autoTableSearch from './auto-table-filter/link-auto-table-search'

const filterComponents = {
    autoTableFilterDatepicker,
    autoTableFilterTimepicker,
    autoTableFilterInput,
    autoTableFilterLov,
    autoTableFilterInputNumber,

    autoTableSearch,
}

const AutoTableController = {
    tables: [],
    add(table) {
        this.tables.push(table)
    },
    remove(table) {
        const index = this.tables.indexOf(table)
        index !== -1 && (this.tables.splice(index, 1))
    },
    getTable(autoOption) {
        for (let i = 0; i < this.tables.length; i++) {
            const table = this.tables[i];
            if (table.option === autoOption) return table
        }
        return null
    }
}

const EDIT_STATUS = {
    NORMAL: 'NORMAL',
    INSERT: 'INSERT',
    UPDATE: 'UPDATE',
    SELECT: 'SELECT'
}


export {
    filterComponents,
    AutoTableController,
    EDIT_STATUS,
}
